import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-send-form-are-you-sure-dialog',
  templateUrl: './send-form-are-you-sure-dialog.component.html',
  styleUrls: ['./send-form-are-you-sure-dialog.component.scss']
})
export class SendFormAreYouSureDialogComponent implements OnInit {

  

  constructor(private router: Router,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<SendFormAreYouSureDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any) { 

     

    }

  ngOnInit(): void {
  }

  onSend(){
    this.dialogRef.close(true);
  }

 

}
